export const usernameReg = /^[a-zA-Z0-9]+$/;

// Only contains alphanumeric characters
